/** Simple deterministic 32-bit string hash (djb2-ish) — no crypto needed, just needs to
 * be stable and reasonably well-distributed across arbitrary uid strings. */
function hashString(input) {
    let hash = 5381;
    for (let i = 0; i < input.length; i++) {
        hash = (hash * 33 + input.charCodeAt(i)) | 0;
    }
    return hash >>> 0;
}
/**
 * Stable per-uid staged rollout (Module 24's `IAP_ROLLOUT_PERCENTAGE`) — the same uid
 * always buckets to the same 0-99 slot, so a player's in/out status doesn't flicker
 * across sessions/reloads as long as `percentage` itself doesn't change. This is the
 * first percentage-rollout mechanism in this codebase; every existing flag is a flat
 * on/off kill switch.
 */
export function isInRollout(uid, percentage) {
    if (percentage <= 0)
        return false;
    if (percentage >= 100)
        return true;
    const bucket = hashString(uid) % 100;
    return bucket < percentage;
}
